import React from 'react';
import { useLocale } from '../contexts/LocaleContext';
import { EmptyStateAddButton } from './EmptyStateAddButton';
import { EmptyStateSecondaryButton } from './EmptyStateSecondaryButton';
import { PanelEmptyState } from './PanelEmptyState';
import { TimelineEmptyIllustration } from './TimelineEmptyIllustration';

interface TimelineEmptyStateProps {
  canEdit: boolean;
  onAdd: () => void;
  onImport: () => void;
}

export const TimelineEmptyState: React.FC<TimelineEmptyStateProps> = ({ canEdit, onAdd, onImport }) => {
  const { t } = useLocale();

  return (
    <PanelEmptyState
      illustration={<TimelineEmptyIllustration />}
      title={t('timeline_empty_title')}
      description={t('timeline_empty_description')}
      actions={
        canEdit ? (
          <>
            <EmptyStateSecondaryButton onClick={onImport}>
              {t('timeline_import')}
            </EmptyStateSecondaryButton>
            <EmptyStateAddButton onClick={onAdd}>{t('add_event')}</EmptyStateAddButton>
          </>
        ) : undefined
      }
    />
  );
};
